import type { ObjectCommentId } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';
import type { Action } from '@atlassian/react-sweet-state';
import type { ObjectActivityTimelineState } from '../../../common/types/store.tsx';
import type { TimelineEventType } from '../../../common/types/timeline-event.tsx';
import { fetchObjectActivity } from './fetch-object-activity/index.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { fetchObjectActivity };
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { fetchChangesAndIncidentsNextPage } from './fetch-changes-and-incidents';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { addObjectComment } from './store-object-comment';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { deleteObjectComment } from './delete-object-comment';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { updateObjectComment } from './update-object-comment';

export const setIsAddingNewComment =
	(): Action<ObjectActivityTimelineState> =>
	({ setState }) => {
		setState({
			commentBeingEdited: 'NEW',
		});
	};

export const setIsEditingComment =
	(commentId: ObjectCommentId): Action<ObjectActivityTimelineState> =>
	({ setState }) => {
		setState({
			commentBeingEdited: commentId,
		});
	};

export const setIsNoCommentBeingEdited =
	(): Action<ObjectActivityTimelineState> =>
	({ setState }) => {
		setState({
			commentBeingEdited: null,
		});
	};

export const setFilteredByEventTypes =
	(filteredByEventTypes: TimelineEventType[]): Action<ObjectActivityTimelineState> =>
	({ setState, dispatch }) => {
		setState({ filteredByEventTypes, timelineEvents: [] });
		dispatch(fetchObjectActivity());
	};

export const setAllowRelativeTimestamp =
	(allowRelativeTimestamp: boolean): Action<ObjectActivityTimelineState> =>
	({ setState }) => {
		setState({ allowRelativeTimestamp });
	};

export const toggleAllowRelativeTimestamp =
	(): Action<ObjectActivityTimelineState> =>
	({ setState, getState }) => {
		setState({ allowRelativeTimestamp: !getState().allowRelativeTimestamp });
	};
